/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateElectricalMeasurementDto } from '../models/work-create-electrical-measurement-dto';
import { WorkElectricalMeasurement } from '../models/work-electrical-measurement';
import { WorkElectricalMeasurementCable } from '../models/work-electrical-measurement-cable';
import { WorkElectricalMeasurementDevice } from '../models/work-electrical-measurement-device';
import { WorkElectricalMeasurementType } from '../models/work-electrical-measurement-type';
import { WorkUpdateElectricalMeasurementDto } from '../models/work-update-electrical-measurement-dto';

@Injectable({ providedIn: 'root' })
export class WorkElectricalMeasurementsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `electricalMeasurementsV1ControllerFindMy()` */
  static readonly ElectricalMeasurementsV1ControllerFindMyPath = '/v1/electrical-measurements/my';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV1ControllerFindMy()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerFindMy$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkElectricalMeasurement>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalMeasurementsService.ElectricalMeasurementsV1ControllerFindMyPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkElectricalMeasurement>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV1ControllerFindMy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerFindMy(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkElectricalMeasurement>> {
    return this.electricalMeasurementsV1ControllerFindMy$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkElectricalMeasurement>>): Array<WorkElectricalMeasurement> => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementsV1ControllerFindAllForProject()` */
  static readonly ElectricalMeasurementsV1ControllerFindAllForProjectPath = '/v1/electrical-measurements/byProjectId/{projectId}';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV1ControllerFindAllForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerFindAllForProject$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkElectricalMeasurement>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalMeasurementsService.ElectricalMeasurementsV1ControllerFindAllForProjectPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkElectricalMeasurement>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV1ControllerFindAllForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerFindAllForProject(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkElectricalMeasurement>> {
    return this.electricalMeasurementsV1ControllerFindAllForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkElectricalMeasurement>>): Array<WorkElectricalMeasurement> => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementsV1ControllerGetDevices()` */
  static readonly ElectricalMeasurementsV1ControllerGetDevicesPath = '/v1/electrical-measurements/devices';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV1ControllerGetDevices()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerGetDevices$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkElectricalMeasurementDevice>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalMeasurementsService.ElectricalMeasurementsV1ControllerGetDevicesPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkElectricalMeasurementDevice>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV1ControllerGetDevices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerGetDevices(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkElectricalMeasurementDevice>> {
    return this.electricalMeasurementsV1ControllerGetDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkElectricalMeasurementDevice>>): Array<WorkElectricalMeasurementDevice> => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementsV1ControllerGetTypes()` */
  static readonly ElectricalMeasurementsV1ControllerGetTypesPath = '/v1/electrical-measurements/types';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV1ControllerGetTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerGetTypes$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkElectricalMeasurementType>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalMeasurementsService.ElectricalMeasurementsV1ControllerGetTypesPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkElectricalMeasurementType>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV1ControllerGetTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerGetTypes(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkElectricalMeasurementType>> {
    return this.electricalMeasurementsV1ControllerGetTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkElectricalMeasurementType>>): Array<WorkElectricalMeasurementType> => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementsV1ControllerGetCables()` */
  static readonly ElectricalMeasurementsV1ControllerGetCablesPath = '/v1/electrical-measurements/cables';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV1ControllerGetCables()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerGetCables$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkElectricalMeasurementCable>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalMeasurementsService.ElectricalMeasurementsV1ControllerGetCablesPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkElectricalMeasurementCable>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV1ControllerGetCables$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerGetCables(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkElectricalMeasurementCable>> {
    return this.electricalMeasurementsV1ControllerGetCables$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkElectricalMeasurementCable>>): Array<WorkElectricalMeasurementCable> => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementsV1ControllerFindOne()` */
  static readonly ElectricalMeasurementsV1ControllerFindOnePath = '/v1/electrical-measurements/{id}';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV1ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkElectricalMeasurement>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalMeasurementsService.ElectricalMeasurementsV1ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkElectricalMeasurement>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV1ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkElectricalMeasurement>> {
    return this.electricalMeasurementsV1ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkElectricalMeasurement>>): Array<WorkElectricalMeasurement> => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementsV1ControllerDelete()` */
  static readonly ElectricalMeasurementsV1ControllerDeletePath = '/v1/electrical-measurements/{id}';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV1ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkElectricalMeasurement>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalMeasurementsService.ElectricalMeasurementsV1ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkElectricalMeasurement>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV1ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV1ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkElectricalMeasurement> {
    return this.electricalMeasurementsV1ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkElectricalMeasurement>): WorkElectricalMeasurement => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementsV1ControllerUpdate()` */
  static readonly ElectricalMeasurementsV1ControllerUpdatePath = '/v1/electrical-measurements/{id}';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV1ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  electricalMeasurementsV1ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateElectricalMeasurementDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkElectricalMeasurement>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalMeasurementsService.ElectricalMeasurementsV1ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkElectricalMeasurement>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV1ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  electricalMeasurementsV1ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateElectricalMeasurementDto
    },
    context?: HttpContext
  ): Observable<WorkElectricalMeasurement> {
    return this.electricalMeasurementsV1ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkElectricalMeasurement>): WorkElectricalMeasurement => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementsV1ControllerCreate()` */
  static readonly ElectricalMeasurementsV1ControllerCreatePath = '/v1/electrical-measurements';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV1ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  electricalMeasurementsV1ControllerCreate$Response(
    params: {
      body: WorkCreateElectricalMeasurementDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalMeasurementsService.ElectricalMeasurementsV1ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV1ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  electricalMeasurementsV1ControllerCreate(
    params: {
      body: WorkCreateElectricalMeasurementDto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.electricalMeasurementsV1ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

}
